<template>
  <div class="supplier-search-wrapper">
    <v-combobox
      v-model="term_chips"
      small-chips
      :rounded="rounded"
      :solo="solo"
      clearable
      outlined
      dense
      label="Enter keywords (searches name, tags, description)"
      multiple
      small
      ref="keywords"
      append-outer-icon="mdi-magnify"
      :dark="dark"
      @click:append-outer="search()"
      @click:clear="clearSearch()"
      class="search-combobox"
    >
      <template v-slot:selection="{ attrs, item, select, selected }">
        <v-chip
          color="primary"
          small
          label
          v-bind="attrs"
          :input-value="selected"
          close
          @click="select"
          @click:close="remove_kw(item)"
          >{{ item }}</v-chip
        >
      </template>
    </v-combobox>
    <div class="d-flex align-center pt-0 mt-0 mb-3">
      <div class="caption grey--text">Include in search</div>
      <v-checkbox
        v-model="include_tags"
        label="Supplier Tags"
        dense
        hide-details
        class="ma-0 pa-0"
        style="flex: 0 0 auto;"
      ></v-checkbox>
      <v-checkbox
        v-model="include_description"
        label="Supplier Description"
        dense
        hide-details
        class="ma-0 pa-0 ml-2"
        style="flex: 0 0 auto;"
      ></v-checkbox>
    </div>
  </div>
</template>

<script>
import { getArray } from "./Utils.js";
import { autocomplete } from "./APIManager.js";

export default {
  props: {
    rounded: Boolean,
    solo: Boolean,
    dark: Boolean,
    color: String
  },

  data() {
    return {
      term_chips: [],
      search_terms: "",
      items: [],
      isLoading: false,
      disable_nav: false,
      lookup_limit: 60,
      entity: {},
      include_tags: true,
      include_description: true
      //show_login_menu: false
    };
  },

  watch: {
    search_terms(val) {
      val && val !== this.select && this.lookup(val);
    }
  },

  mounted() {
    var query = this.$route.query;

    if (query.hasOwnProperty("term")) {
      this.term_chips = getArray(query["term"]);
    }
    
    // Load search flags from route if present
    if (query.hasOwnProperty("include_tags")) {
      this.include_tags = query.include_tags === 'true' || query.include_tags === true;
    }
    if (query.hasOwnProperty("include_description")) {
      this.include_description = query.include_description === 'true' || query.include_description === true;
    }
  },

  methods: {

    remove_kw(item) {
      this.term_chips.splice(this.term_chips.indexOf(item), 1);
      this.term_chips = [...this.term_chips];
      if (this.term_chips.length == 0){
        this.clearSearch()
      }else{
        this.search()
      }
    },

    search(){
      ////////////console.log("IN SEARCH for: ", this.entity.key);
      var qry = JSON.parse(JSON.stringify(this.$route.query));
      // Always remove previous term and reset page to ensure route change
      delete qry["term"];
      delete qry["page"];
      const page_num = 1;

      // Build query with search terms and flags
      const nextQuery = { ...qry, page: page_num };
      
      if (this.term_chips.length > 0) {
        nextQuery.term = this.term_chips;
      }
      
      // Include search flags
      nextQuery.include_tags = this.include_tags;
      nextQuery.include_description = this.include_description;

      // Emit search event to parent so it can handle filter merging and reload
      // This ensures reload happens even if route navigation fails
      this.$emit('search', nextQuery);

      // Always push to ensure route change triggers watchers
      // Even if navigation is "duplicated", the event handler will trigger reload
      this.$router.push({ query: nextQuery }).catch(err => {
        // Ignore navigation duplicated errors - emit event will trigger reload
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        } else {
          // If navigation is duplicated, still emit event to trigger reload
          this.$emit('search', nextQuery);
        }
      });
    },

    clearSearch() {
      this.term_chips = [];
      this.$emit("clearFilter", true);
    },

    getSupplier(supplier_id) {
      this.$emit("close-entity-menu");
      this.$router.push({ name: "supplier", params: { id: supplier_id } });
    },

    lookup(terms) {
      // Lazily load input items
      this.isLoading = true;
      autocomplete(this.search_terms, "supplier")
        .then(data => {
          data.unshift({ key: terms }); 
          this.items = data;
        })
        .finally(() => (this.isLoading = false));
    },

    disabled() {
      if (localStorage.getItem("isLoggedIn") == "1") {
        this.disable_nav = false;
        return this.disable_nav;
      } else {
        this.disable_nav = true;
        return this.disable_nav;
      }
    }
  }
};
</script>

<style scoped>
.supplier-search-wrapper {
    display: flex;
    flex-direction: column;
}

.search-combobox {
    margin-bottom: 0;
}
</style>
